export default __webpack_public_path__ + "./fonts/radio-unchecked.b3b7b926.svg";